import { NavItem, NavLink, Nav } from "reactstrap";
import { version } from "../../../package.json";

function AuthFooter() {
  return (
    <>
      <footer id="footer-main">
        <div className="tw:flex tw:flex-col tw:w-full tw:md:flex-row tw:justify-center tw:md:justify-between tw:items-center tw:py-7">
          <div className="tw:text-center tw:text-medium tw:text-sm">
            © {new Date().getFullYear()}{" "}
            <a
              className="tw:text-medium tw:ml-1"
              href="https://www.growthcloud.com"
              target="_blank"
              rel="norefferer"
            >
              GrowthCloud
            </a>
            <span className="tw:pl-2">v{version ? version : "DEV"}</span>
          </div>

          <div>
            <Nav className="nav-footer tw:md:justify-center">
              <NavItem>
                <NavLink
                  className="tw:text-medium tw:p-1 tw:text-sm"
                  href="/privacy"
                  target="_blank"
                >
                  Privacy
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="tw:text-medium tw:p-1 tw:text-sm"
                  href="/terms"
                  target="_blank"
                >
                  Terms
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="tw:text-medium tw:p-1 tw:text-sm"
                  href="https://www.growthcloud.com/support"
                  target="_blank"
                >
                  Support
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
      </footer>
    </>
  );
}

export default AuthFooter;
